let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("22pZ8")).then(() => parcelRequire('j96ER'));